import React from "react";
import { Result, Typography } from "antd";

const { Paragraph, Text } = Typography;

export default function Done() {


  return (
    <>
      <Result title="Check your Email">
        <div className="desc">
          <Paragraph>
            <Text
              strong
              style={{
                fontSize: 16,
                textAlign: "center",
              }}
            >
              <p>
                An email has been sent to you to activate your account. <br />
                Check your inbox or spam folder for further instruction.
              </p>
            </Text>
          </Paragraph>
        </div>
      </Result>
    </>
  );
}
